import { Pipe } from '@angular/core';
import { isNil } from 'lodash';
import { TreeviewItem } from './treeview-item';
import * as ɵngcc0 from '@angular/core';
var TreeviewPipe = /** @class */ (function () {
    function TreeviewPipe() {
    }
    TreeviewPipe.prototype.transform = function (objects, textField) {
        if (isNil(objects)) {
            return undefined;
        }
        return objects.map(function (object) { return new TreeviewItem({ text: object[textField], value: object }); });
    };
TreeviewPipe.ɵfac = function TreeviewPipe_Factory(t) { return new (t || TreeviewPipe)(); };
TreeviewPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "ngxTreeview", type: TreeviewPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TreeviewPipe, [{
        type: Pipe,
        args: [{
                name: 'ngxTreeview'
            }]
    }], function () { return []; }, null); })();
    return TreeviewPipe;
}());
export { TreeviewPipe };

